import intlTelInput from 'intl-tel-input';
//import utils from 'intl-tel-input';

(() => {
  const inputs = document.querySelectorAll('input[type="tel"]');
  if (inputs.length > 0) {
    function initTel(countryCode) {
      var updateField = function (input) {
        var hidden = input.parentNode.querySelector('input[type="hidden"]');
        if (hidden) {
          var iti = window.intlTelInputGlobals.getInstance(input);
          if (iti.isValidNumber()) hidden.value = iti.getNumber();
        }
      };
      inputs.forEach(function (input) {
        intlTelInput(input, {
          initialCountry: countryCode,
          hiddenInput: 'phone',
          utilsScript: window.routes.asset_url + 'intlTelInput-utils.js'
        });
        input.setAttribute('name', '');
        input.addEventListener('change', function (event) {
          updateField(event.target);
        });
        input.addEventListener('keyup', function (event) {
          updateField(event.target);
        });
        input.addEventListener('blur', function (event) {
          updateField(event.target);
        });
      });
    }
    initTel(window.Shopify.country.toLowerCase() || 'gb');
  }
})();